// 查看银行回单
import { receiptDetail, receiptDetailByBusinessNo } from '@/api/consignment'
import { dateFormat1 } from '@/utils/util'
import axios from 'axios'
import {
  Message,
  Loading
} from 'element-ui'
export const chaKanHuiDan = (capitalSerialno, queryDate, extertransType) => {
  if (extertransType) { // 结算单银行回单查看, 上游结算单传值 2, 下游结算单传3
    let loadingInstance = Loading.service({
      lock: true,
      text: '正在加载...'
    })
    receiptDetailByBusinessNo({ businessNo: capitalSerialno, extertransType: extertransType }).then(res => {
      loadingInstance.close()
      viewPdf(res)
    }).catch(error => {
      Message({
        showClose: true,
        message: error.message,
        type: 'error',
        onClose () {
          loadingInstance.close()
        }
      })
    })
  } else {
    let loadingInstance = Loading.service({
      lock: true,
      text: '正在加载...'
    })
    receiptDetail({ capitalSerialno: capitalSerialno, queryDate: dateFormat1(Number(queryDate)) }).then(res => {
      loadingInstance.close()
      viewPdf(res)
    }).catch(error => {
      Message({
        showClose: true,
        message: error.message,
        type: 'error',
        onClose () {
          loadingInstance.close()
        }
      })
    })
  }
  function viewPdf (content) {
    if (!content) {
      this.$message.error('暂无意见')
      return
    }
    const blob = base64ToBlob(content)
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob)
    } else {
      const fileURL = URL.createObjectURL(blob)
      // window.open(fileURL)
      newLink(fileURL)
    }
  }
  function newLink (url) {
    let newLink = window.open('loading page')
    axios.get(url)
      .then(function (response) {
        newLink.location.href = url
      })
      .catch(function (error) {
        console.log(error)
      })
  }
  function base64ToBlob (code) {
    code = code.replace(/[\n\r]/g, '')
    // atob() 方法用于解码使用 base-64 编码的字符串。
    const raw = window.atob(code)
    const rawLength = raw.length
    const uInt8Array = new Uint8Array(rawLength)
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i)
    }
    return new Blob([uInt8Array], { type: 'application/pdf' })
  }
}
